module.exports = __webpack_public_path__ + "img/czf_img_4@2x.58de1801.png";